module.exports = __webpack_public_path__ + "static/media/cart-plus.3ec43552.svg";